/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const DonTBreatheIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M48.8 26.6c-1.4-5-3.8-9.5-7.2-13.4-1.3-1.5-3-2.7-4.8-3.5-1.2-.6-2.7-.6-4-.2-1.4.6-2.5 1.8-3 3.3-.2.6-.4 1.1-.5 1.7-.1.2-.1.4-.2.7-1-.1-1.6-1-1.5-2v-5c.1-.6-.3-1.1-.9-1.1h-.1c-.3 0-.5.1-.7.3-.2.2-.3.6-.3.9v5.4c0 .5.1 1.1.4 1.5.5 1 1.5 1.7 2.6 1.9.1 0 .2.1.2.1 0 .3 0 .6-.1 1v.2h-.2c-1-.2-1.9-.7-2.7-1.4-.4-.5-1-.5-1.5-.2l-.2.2c-.3.3-.6.5-.9.7-.6.4-1.3.6-2 .7v-.2c0-.2 0-.4-.1-.6v-.4c.1-.1.2-.1.3-.1.2 0 .4-.1.6-.2 1.2-.4 2.1-1.5 2.2-2.8.1-2 0-4 0-6-.1-.4-.3-.7-.6-.8-.4-.1-.7 0-1 .2-.2.3-.3.6-.3.9v5c0 .9-.6 1.6-1.5 1.7l-.2-.6c-.2-.6-.3-1.2-.5-1.7-.4-1.2-1.1-2.2-2.1-2.9-1.5-.9-3.3-1-4.8-.3-2.1.9-4 2.3-5.4 4.2-3 3.7-5.3 7.9-6.6 12.5C.1 29.8-.3 33.4.1 37.1c.1 1 .4 2.1.9 3 1 1.9 3 3.1 5.2 2.8 1.6-.1 3.1-.4 4.6-1 2.4-.6 4.7-1.7 6.7-3.2 2.3-1.7 3.8-4.3 3.9-7.2.1-2.2.1-4.4 0-6.6v-4.5c1.3-.2 2.4-.7 3.5-1.5h.1c1 .8 2.3 1.3 3.5 1.5v3.5c0 2.2 0 4.3-.1 6.5-.1 3.5 1.5 6.7 4.4 8.7 1.8 1.3 3.9 2.2 6 2.8 1.6.6 3.3.9 5 1.1h.5c2.3 0 4.3-1.5 4.9-3.7.3-.9.5-1.9.6-2.9.4-3.3 0-6.7-1-9.8zm-18.4-.9c0-.8.1-1.6.1-2.4.1-1.9.2-4 .4-5.9.1-1.5.5-3 1.1-4.5.3-1 1.3-1.7 2.4-1.7.9 0 1.8.3 2.6.7 1.8 1.1 3.4 2.5 4.6 4.3 3.1 4.3 5.3 9.3 6.2 14.5.5 2.4.5 4.8 0 7.2 0 .1 0 .2-.1.3-.4 1.9-2.3 3-4.2 2.6-2.4-.4-4.6-1.1-6.8-2.1-1.8-.7-3.3-1.9-4.5-3.4-.9-1.2-1.4-2.6-1.5-4.1v-5.4l-.3-.1zm-10.9 4.9c.1 2.9-1.5 5.6-4 7-2.7 1.7-5.7 2.7-8.8 3.2-.6.1-1.2.1-1.8-.1-1.2-.3-2.2-1.2-2.4-2.5-.5-2-.7-4.1-.3-6.2.6-4.4 2-8.7 4.2-12.5 1.1-2.1 2.6-4.1 4.3-5.8 1-1.1 2.3-1.9 3.6-2.3.1-.1.3-.1.4-.2.3-.1.6-.1.9-.1 1.2 0 2.2.7 2.6 1.8.6 1.4 1 2.9 1.1 4.4.2 2 .3 4.1.4 6.1 0 .8.1 1.6.1 2.4h-.1v1.3c-.2 1.3-.2 2.4-.2 3.5z' />
		</svg>
	)
}

export default DonTBreatheIcon
